import _ from "lodash";
import moment from "moment";
import axios from "axios";
import { ENDPOINT } from "../../constants/endpoint.js";

const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwNzA2NTcyLCJleHAiOjI3MjY2ODA3MjM0NTcyLCJqdGkiOiIxNGNjNzI3Ny1kODg4LTQwZGUtODZkZi1iNDkzY2RhMzYzNTgifQ.1uhBK4cq-QhM_w21B2iPQLrPWB6kpf5l-fJt4iROO6E";
const token2 =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwODM3NTM3LCJleHAiOjI3MjY2ODA3MzY1NTM3LCJqdGkiOiI3Y2E2NzYwNC1lN2UwLTQ0ZWUtYjY1Ny0wM2EzMDkyNWMwMzcifQ.9YLNDUd2DO6qnlnGfyrdzQRGaeFBE2adWcHWaEV-z_0";

const state = {
  loading: false,
  error: {},
  data: [],
  focusId: null,
  mpTanker: null,
  mpVessel: [],
  mpTankerCapacity: [],
  mpTankerAll: [],
  mpTankerValue: [],
  mpVesselAll: [],
  mpStations: [],
  mpStation: null,
  mpForWardTanker: null,
  totalReceivedOilTanker: null
};

const getters = {
  getCapacity: (state) => () => {
    const capacity = _.get(state, "mpTanker.capacity", 0);
    if (capacity == null) return 0;
    return capacity;
  },
  getTransferValue: (state) => () => {
    const { mpTankerCapacity } = state;
    // const volumes = _.sum(_.map(mpTankerCapacity, (a) => {
    //   return Number(a.total_transfer);
    // }));
    // console.log(volumes);
    // if (volumes == null) return 0;
    // return Math.abs(volumes);

    const capacity = _.last(mpTankerCapacity);
    const value = _.get(capacity, "total_transfer", 0);
    if (value == null) return 0;
    // console.log(mpTankerCapacity, value);
    return Math.abs(value);
  },
  getTankerAll: (state) => {
    return state.mpTankerAll; 
  },
  getTankerbyMMSI: (state) => (mmsi)=> {
    return _.find(state.mpTankerAll,{"mmsi": mmsi}); 
  },
  getTankerByID: (state) => (id)=> {
    console.log("getTankerByID", id, state.mpTankerAll);
    return _.find(state.mpTankerAll,{"id": id}); 
  },
  getVesselByID: (state) => {
    return state.mpVessel; 
  },
  getMpTankerName: (state) => (id) => {
    const { mpTankerAll } = state;
    const tanker = _.find(mpTankerAll,{"id" : id });
    const name = _.get(tanker,"name");
    return name;
  },
  getMpVesselName: (state) => (id) => {
    const { mpVesselAll } = state;
    const mpVessels = _.find(mpVesselAll,{"id" : id });
    const name = _.get(mpVessels,"name");
    return name;
  },
  getTankerValue: (state) => () => {
    //จ่ายทั้งหมด
    const { mpTankerValue } = state
    console.log("จ่ายทั้งหมด >> ",mpTankerValue);
    // let sumVolume = 0
    // for (const mpTanker of mpTankerValue) {
    //   const volumes = _.sum(_.map(mpTanker.volumes, (a) => {
    //     return Number(a);
    //   }));
    //   console.log("volumes ", volumes);
    //   sumVolume += volumes
    // }
    const volumes = _.get(mpTankerValue[0], "volumes");
    const total = _.sumBy(volumes,(volume) => {
      return parseInt(volume) 
    })
    return total;
  },
};

const actions = {
  getMpTankerByMMSI(context, params) {
    const mmsi = _.get(params, "mmsi", 0);
    $.ajax({
      url: `${ENDPOINT.MP_TANKERS}?q[mmsi_eq]=${mmsi}`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const data = _.find(result, { mmsi });
        context.commit("SET_MP_TANKER_DETAIL_SUCCESS", { data });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_DETAIL_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  getMpTankerVolume(context, params) {
    const start = _.get(params, "date.startDate", "");
    const end = _.get(params, "date.endDate", "");
    const statementGteq = moment(start, "DD/MM/YYYY").format("YYYY-MM-DD");
    const statementLteq = moment(end, "DD/MM/YYYY").format("YYYY-MM-DD");
    const mmsi = params.mmsi;
    const config = {
      params: {
        "q[departed_at_gt]": statementGteq,
        "q[departed_at_lt]": statementLteq,
        "q[vessel_loads_destination_type_eq]": params.destination_type,
        domestic: params.isDomestic,
        "q[workflow_state_cont]": "approved",
      },
      headers: {
        "X-User-Email": "api_truck@petrol.excise-online.com",
        "X-User-Token": "ofFd99ZSDTpKzxTeV-Ts",
      },
    };
    const url = ENDPOINT.VESSEL_TRIPS;
    axios
      .get(url, config)
      .then((res) => {
        const values = res.data.filter((a) => {
          const { vessel } = a;
          if (vessel.mmsi == mmsi) {
            return true;
          }
          return false;
        });
        console.log("state mpTankerValue  >>>> ", values);
        context.commit("SET_MP_VALUE_SUCCESS", { values });
      })
      .catch((e) => {
        context.commit("SET_MP_VALUE_FAIL", { error: e });
      });
  },
  getMpCapacityDetail(content, params) {
    const id = _.get(params, "id", 0);
    const start = _.get(params, "date.startDate", "");
    const end = _.get(params, "date.endDate", "");

    const statementGteq = moment(start, "DD/MM/YYYY").format("YYYY-MM-DD");
    const statementLteq = moment(end, "DD/MM/YYYY").format("YYYY-MM-DD");
    const st = `q[statement_date_gteq]=${statementGteq}`;
    const ed = `q[statement_date_lteq]=${statementLteq}`;
    $.ajax({
      url: `https://mp-new.excise-online.com/transfer_statements.json?q[tanker_id_eq]=${id}&${st}&${ed}`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token2}`);
      },
      success: (result) => {
        const data = result;
        content.commit("SET_MP_TANKER_CAPACITY_SUCCESS", { data });
      },
      error: (e) => {
        // error
        content.commit("SET_MP_TANKER_CAPACITY_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  async getMpTankerAll(context) {
    const url = ENDPOINT.MP_TANKERS;
    return await axios
      .get(url)
      .then((res) => {
        context.commit("SET_MP_TANKER_ALL_SUCCESS", { mpTankerAll: res.data });
      });
  },
  async getMpVesselAll(context) {
    await $.ajax({
      url: ENDPOINT.MP_VESSELS,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const mpVesselAll = result;
        context.commit("SET_MP_VESSEL_ALL_SUCCESS", { mpVesselAll });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_ALL_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  async getMpVesselById(context, params) {
    // context.commit("SET_MP_VESSEL_NULL");
    const vessel_id = params.vessel_id;
    
    const url = ENDPOINT.MP_VESSELS;
    return await axios
      .get(url, {
        params: {
          'q[id_eq]': vessel_id,
        }
      })
      .then((res) => {
        const data = {
          ...res.data[0],
          type: "vessel"
        }
        context.commit("SET_MP_VESSEL_BY_ID", { data });
      });
  },
  async getMpStations(context) {
    const url = ENDPOINT.MP_STATIONS;
    return await axios
      .get(url)
      .then((res) => {
        context.commit("SET_MP_STATION_ALL", { mpStations: res.data });
      });
  },
  async getMpStationById(context, params) {
    // context.commit("SET_MP_VESSEL_NULL");
    const station_id = params
    const url = ENDPOINT.MP_STATIONS;
    return await axios
      .get(url, {
        params: {
          'q[id_eq]': station_id,
        }
      })
      .then((res) => {
        const data = {
          ...res.data[0],
          type: "station"
        }
        context.commit("SET_MP_STATION_BY_ID", { data });
      });
  },
  async getMpTankerById(context, params) {
    const tanker_id = params

    const url = ENDPOINT.MP_TANKERS;
    return await axios
      .get(url, {
        params: {
          'q[id_eq]': tanker_id,
        }
      })
      .then((res) => {
        const data = {
          ...res.data[0],
          type: "tanker"
        }

        context.commit("SET_MP_TANKER_DETAIL_SUCCESS", { data });
      });
  },
  async getMpForWardTankerById(context, params) {
    const tanker_id = params
    const url = ENDPOINT.MP_TANKERS;
    return await axios
      .get(url, {
        params: {
          'q[id_eq]': tanker_id,
        }
      })
      .then((res) => {
        const data = {
          ...res.data[0],
          type: "forwardTanker"
        }
        context.commit("SET_MP_FORWARD_TANKER_DETAIL_SUCCESS", { data });
      });
  },
  setTotalReceivedOilTanker(context, volume) {
    context.commit("SET_TOTAL_RECEIVED_OIL_TANKER", volume);
  }
};

const mutations = {
  SET_MP_VESSEL_NULL(){
    state.mpVessel = [];
  },
  SET_MP_VESSEL_BY_ID(state, payload) {
    state.mpVessel = payload.data;
    // state.mpVessel.push(...payload.data);
    // state.mpVessel = _.uniqBy(state.mpVessel, "id");
    // console.log(state.mpVessel);
  },
  SET_MP_STATION_BY_ID(state, payload){
    state.mpStation = payload.data;
  },
  SET_MP_VALUE_SUCCESS(state, payload) {
    state.mpTankerValue = payload.values;
  },
  SET_MP_VALUE_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_DETAIL_SUCCESS(state, payload) {
    state.mpTanker = payload.data;
  },
  SET_MP_FORWARD_TANKER_DETAIL_SUCCESS(state, payload) {
    state.mpForWardTanker = payload.data;
  },
  SET_MP_TANKER_DETAIL_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_CAPACITY_SUCCESS(state, payload) {
    state.mpTankerCapacity = payload.data || {};
  },
  SET_MP_TANKER_CAPACITY_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_ALL_SUCCESS(state, payload) {
    state.mpTankerAll = payload.mpTankerAll;
  },
  SET_MP_VESSEL_ALL_SUCCESS(state, payload) {
    state.mpVesselAll = payload.mpVesselAll;
  },
  SET_MP_TANKER_ALL_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_STATION_ALL(state, payload) {
    state.mpStations = payload.mpStations;
  },
  SET_TOTAL_RECEIVED_OIL_TANKER(state, volume) {
    state.totalReceivedOilTanker = volume;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
